export default "__VITE_ASSET__CZbCwWt7__"